import * as d3 from "d3";
import { opacityToColor } from "./Data_Processing";

export const drawSvg = (constants, sharedFeatures) => {
  const { containerRef, setSidebar } = sharedFeatures;
  let svg;
  let { width, height, fontSize } = constants;

  d3.select(containerRef.current).selectAll("svg").remove();

  svg = d3
    .select(containerRef.current)
    .append("svg")
    .attr("width", "100%")
    .attr("height", "100%")
    .attr("viewBox", `0 0 ` + width + ` ` + height);

  // draw svg background
  svg
    .append("rect")
    .attr("fill", "#fff")
    .attr("height", height)
    .attr("width", width)
    .style("font-size", fontSize)
    .on("click", () => {
      setSidebar(null);
      d3.selectAll(".node-image").style("opacity", (d) => d.recent);
      d3.selectAll(".link").style("opacity", (d) => d.recent);
      d3.selectAll(".node-text").style("stroke", (d) =>
        opacityToColor(d.recent)
      );
      d3.selectAll(".node-text").style("color", (d) =>
        opacityToColor(d.recent)
      );
    });

  return svg;
};
